import { ChatBotFlowType } from "@/protocols/chatBot"

export const handleCopyChatBotUrlOnClick = (chatBotFlowId?: number, chatBotType?: ChatBotFlowType) => {
	const isDevEnv = process.env.NODE_ENV === "development"
	const formatedChatBotType = chatBotType === "chat-bot" ? "bots" : "flow"
	const chatBotUrl = isDevEnv ? `http://localhost:4100/admin/${formatedChatBotType}/${chatBotFlowId}` : `https://cp.letalk.com.br/admin/${formatedChatBotType}/${chatBotFlowId}`
	window.open(`${chatBotUrl}`, "_blank")
	navigator.clipboard.writeText(`${chatBotUrl}${chatBotFlowId}`)
}
